import { useUIStore } from "../../store/uiStore";
import { drawerPalette } from "../../lib/drawerTheme";

interface Props {
  hasCachedVlm: boolean;
  hasCachedEquity: boolean;
}

export function EvidenceCache({ hasCachedVlm, hasCachedEquity }: Props) {
  const theme = useUIStore((s) => s.theme);
  const palette = drawerPalette(theme);
  if (!hasCachedVlm && !hasCachedEquity) {
    // R10 mitigation: surface cache-miss UX explicitly so users understand
    // the demo's coverage limit (20 representative cells out of 7,154).
    return (
      <div
        style={{
          padding: "6px 10px",
          fontSize: 11,
          color: palette.mutedText,
          background: palette.panelBg,
          border: `1px solid ${palette.panelBorder}`,
          borderRadius: 4,
          marginTop: 4,
        }}
      >
        On-demand evidence only — this cell has no pre-cached VLM/equity findings.
        Ask a question in the chat to compute them live.
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "6px 10px",
        fontSize: 11,
        color: palette.noticeOkText,
        background: palette.noticeOkBg,
        border: `1px solid ${palette.noticeOkBorder}`,
        borderRadius: 4,
        marginTop: 4,
      }}
    >
      ✓ {hasCachedVlm && "VLM evidence available"}
      {hasCachedVlm && hasCachedEquity && " · "}
      {hasCachedEquity && "Equity audit cached"}
    </div>
  );
}
